import CapitalGainChartCard from "../components/cards/CapitalGainChartCard";
import Container from "../components/Container";
import RentabilityViewCard from "../components/cards/RentabilityViewCard";
import GoalViewCard from "../components/cards/GoalViewCard";
import FutureEventsCard from "../components/cards/FutureEventsCard";
import AssetAllocationCard from "../components/cards/AssetAllocationCard";
import { useEffect, useState } from "react";
import useAuthHttp from "../hooks/useAuthHttp";
import { useMutation } from "@tanstack/react-query";
import { messagingToken } from "../../firebase";
import InsightsContent from "../components/InsightsContent";
import { Sidebar } from "primereact/sidebar";
import InvestorProfileForm from "../components/InvestorProfileForm";
import Card from "../components/Card";
import { useHomeContext } from "../contexts/HomeContext";
import { useAssetSidebarContext } from "../contexts/AssetSidebarContext";
import EmptyWalletState from "../components/EmptyWalletState";

export default function HomePage() {
    const authHttp = useAuthHttp();
    const homeContext = useHomeContext();
    const assetSidebarContext = useAssetSidebarContext();
    const [investorProfileOpen, setInvestorProfileOpen] = useState(false);
    const sendPushTokenNotifcationMutation = useMutation({
        mutationFn: (token: string) => {
            if (!token) {
                return Promise.resolve(null);
            }

            return authHttp.doPatch("/user/notification", { notification_token: token, web: true });
        }
    });

    useEffect(() => {
        Notification.requestPermission().then(async (permission) => {
            if (permission === 'granted') {
                await sendPushTokenNotifcationMutation.mutateAsync(await messagingToken);
            }
        });
    }, []);

    const isWalletEmpty = !homeContext.wallet?.totalValue || homeContext.wallet.totalValue === 0;

    return (
        <>
            <Sidebar
                visible={investorProfileOpen}
                position="right"
                onHide={() => setInvestorProfileOpen(false)}
            >
                <InvestorProfileForm />
            </Sidebar>
            
            {isWalletEmpty && !homeContext.isLoading ? (
                <EmptyWalletState onAddAsset={() => assetSidebarContext.openAssetSidebar()} />
            ) : (
                <Container flexColumn fullWidth gap={3}>
                    <Container wrap gap={2}>
                        <CapitalGainChartCard />
                        <RentabilityViewCard />
                        <GoalViewCard />
                        <FutureEventsCard />
                    </Container>

                    <Container wrap>
                        <AssetAllocationCard />
                    </Container>

                    <Container wrap>
                        <Card
                            title="Insights da carteira"
                            subTitle="Acompanhe os insights da sua carteira gerado pelo nosso modelo de IA"
                        >
                            <InsightsContent setInvestorProfileOpen={setInvestorProfileOpen} />
                        </Card>
                    </Container>
                </Container>
            )}
        </>
    )
}
